(<template>
  <div class="form" id="sign-in-form">
    <h1 v-translate>Sign in</h1>
    <el-form :model="signInForm"
             :rules="rules"
             ref="signInForm"
             label-position="left"
             label-width="12em">
      <el-form-item prop="username">
        <span slot="label" v-translate>Username</span>
        <el-input v-model="signInForm.username"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <span slot="label" v-translate>Password</span>
        <el-input :type="password.type" v-model="signInForm.password">
          <el-button slot="append" :icon="password.icon" @click="showPassword"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button id="login-button" type="primary" @click="ready('signInForm')">
          <span v-translate>Sign in</span>
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>)

(<script>
import axios from 'axios'

export default {
  name: 'sign-in',
  data () {
    return {
      password: {
        visible: false,
        type: 'password',
        icon: 'el-icon-fa-eye'
      },
      signInForm: {
        username: '',
        password: ''
      },
      rules: {
        username: {
          type: 'string',
          required: true,
          message: this.$gettext('Please enter username')
        },
        password: {
          type: 'string',
          required: true,
          message: this.$gettext('Please enter password')
        }
      }
    }
  },
  methods: {
    showPassword () {
      if (!this.password.visible) {
        this.password.type = 'text'
        this.password.icon = 'el-icon-fa-eye-slash'
        this.password.visible = true
      } else {
        this.password.type = 'password'
        this.password.icon = 'el-icon-fa-eye'
        this.password.visible = false
      }
    },
    signIn () {
      axios({
        method: 'post',
        url: `${process.env.SERVER_URL}/auth/login`,
        withCredentials: true,
        auth: {
          username: this.signInForm.username,
          password: this.signInForm.password
        }
      })
      .then(response => {
        this.$message({
          type: 'success',
          message: this.$gettext('Signed in')
        })
        this.$session.set('id', response.data.id)
        this.$session.set('username', response.data.username)
        this.$session.set('email', response.data.email)
        this.$session.set('role', response.data.role)
        this.$router.push('monuments/list')
      })
      .catch(error => {
        var msg
        if (error.response) {
          if (error.response.status === 404) {
            msg = this.$gettext('Wrong username or password')
          } else {
            msg = error.response.statusText
          }
        } else {
          msg = error.message
        }
        this.$message({
          type: 'error',
          message: msg
        })
      })
    },
    ready (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.signIn()
        }
      })
    }
  }
}
</script>)

(
<style>
#sign-in-form {
  width: 30em;
}
</style>
)



// WEBPACK FOOTER //
// src/components/Sign-In.vue